
import Vue from 'vue'
import initialStateTourist from './initialState'

const mutations = {
  setTourists(state, { numberOfTourists }) {
    const touristsForm = Array(numberOfTourists).fill(initialStateTourist())
      .map((item, i) => ({ ...item, id: i }))

    Vue.set(state, 'touristsForm', [...touristsForm])
  },
  setBookingErrors(state, errors) {
    Vue.set(state, 'touristsFormErrors', [...errors])
  },
  setTouristsRooms(state, rooms) {
    const result = rooms.map(room => ({
      ...room,
      ages: room.ages ?? []
    }))

    Vue.set(state, 'rooms', result)
  },
}

export default mutations